<template>
  <div class="animated fadeIn">
    <form>
      <b-row>
        <b-col sm="12">
          <b-card
            id="card-relatorio-nfe"
            :bg-variant="isDark ? 'dark' : 'white'"
            :text-variant="isDark ? 'light' : 'dark'"
            :footer-bg-variant="isDark ? 'dark' : 'light'">
            <div class="p-4 d-flex align-items-center justify-content-between" :class="isDark ? 'bg-secondary-soft' : 'bg-primary-soft'">
              <div>
                <h4 class="mb-1 font-weight-bold" :class="isDark ? 'text-white' : 'text-primary'">
                  <i class="fa fa-file-text-o mr-2"></i>Relatorio de Notas Fiscais
                </h4>
                <span class="text-muted d-block">Gere relatorios HTML de NF-e com agrupamento obrigatorio por CFOP.</span>
              </div>
            </div>

            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-list-alt mr-2"></i>Tipo de Relatorio</h6>
              <b-row>
                <b-col md="8" sm="12">
                  <b-form-group label="Modelo">
                    <b-form-select
                      v-model="tipoRelatorio"
                      :options="opcoesRelatorio"
                      :plain="true"
                      class="form-control-lg"
                      :class="isDark ? 'bg-secondary text-white border-info' : 'select-premium'"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                  <b-form-group label="Situacao">
                    <b-form-select
                      v-model="situacao.valor"
                      :options="situacao.opcoes"
                      :plain="true"
                      class="form-control-lg"
                      :class="isDark ? 'bg-secondary text-white border-info' : 'select-premium'"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-users mr-2"></i>Pessoas</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Remetente/Destinatario">
                    <cliente-pesquisa
                      @retornaId="filtros.remetenteDestinatarioId = $event"
                      :idInicial="filtros.remetenteDestinatarioId"
                      label=""
                      place="Todos"
                      labelBotao=""
                      ref="remetenteDestinatarioPesquisa"
                      idModal="clienteNfeRelatorioModal">
                    </cliente-pesquisa>
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Remetente">
                    <empresa-drop-down
                      v-model="filtros.remetenteId"
                      ref="remetentePesquisa"
                      placeholder="Todos os remetentes"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-cubes mr-2"></i>Produtos e Fiscal</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="CFOP">
                    <CFOPDropDown
                      v-model="filtros.cfopId"
                      ref="cfopPesquisa"
                      placeholder="Todos os CFOPs"
                      input-class="form-control-lg"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Produto">
                    <produto-pesquisa
                      @retornaId="filtros.produtoId = $event"
                      :idInicial="filtros.produtoId"
                      label=""
                      place="Todos os produtos"
                      labelBotao=""
                      ref="produtoPesquisa">
                    </produto-pesquisa>
                  </b-form-group>
                </b-col>
                <b-col md="12" sm="12">
                  <b-form-group label="Grupo de Produto">
                    <grupo-produto-drop-down
                      v-model="filtros.grupoProdutoId"
                      ref="grupoProdutoPesquisa"
                      placeholder="Todos os grupos"
                      input-class="form-control-lg"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div class="section-container mb-2" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-calendar mr-2"></i>Periodo</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Data Inicial de Emissao">
                    <cec-input-data id="nfeRelDt1" v-model="filtros.dt1" :state="filtros.dt1 ? null : false" />
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Data Final de Emissao">
                    <cec-input-data id="nfeRelDt2" v-model="filtros.dt2" :state="filtros.dt2 ? null : false" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div class="card-footer-action p-4 text-center mt-2" :class="isDark ? 'bg-dark-darker' : 'bg-white'">
              <b-button size="lg" type="button" variant="primary" @click.stop.prevent="gerarRelatorio()" class="px-5 py-3 btn-pill shadow-lg btn-generate">
                <i class="fa fa-file-text-o mr-2"></i> GERAR RELATORIO DE NF-E
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import moment from 'moment'
import ClientePesquisa from '../pesquisa/ClientePesquisa.vue'
import ProdutoPesquisa from '../pesquisa/ProdutoPesquisa.vue'
import EmpresaDropDown from '../componentes/dropdown/EmpresaDropDown.vue'
import GrupoProdutoDropDown from '../componentes/dropdown/GrupoProdutoDropDown.vue'
import CFOPDropDown from '../componentes/dropdown/CFOPDropDown.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import Tools from '@/tools/tools.js'
import { printGroupedHtmlReport } from '@/utils/RelatorioHTML.js'

const TIPOS_RELATORIO = [
  { value: 'SINTETICO_DIA', text: 'Sintetico Agrupado por Dia', familia: 'SINTETICO', agrupamentoPrimario: 'DIA' },
  { value: 'SINTETICO_CFOP', text: 'Sintetico Agrupado por CFOP', familia: 'SINTETICO', agrupamentoPrimario: 'CFOP' },
  { value: 'SINTETICO_PRODUTO', text: 'Sintetico Agrupado por Produto', familia: 'SINTETICO', agrupamentoPrimario: 'PRODUTO' },
  { value: 'SINTETICO_PESSOA', text: 'Sintetico Agrupado por Remetente/Destinatario', familia: 'SINTETICO', agrupamentoPrimario: 'PESSOA' },
  { value: 'SINTETICO_TIPO', text: 'Sintetico Agrupado por Tipo de Emissao', familia: 'SINTETICO', agrupamentoPrimario: 'TIPO' },
  { value: 'ACUMULADO_CLIENTE', text: 'Acumulado por Cliente', familia: 'ACUMULADO', agrupamentoPrimario: 'CLIENTE' },
  { value: 'ACUMULADO_NCM', text: 'Acumulado por NCM', familia: 'ACUMULADO', agrupamentoPrimario: 'NCM' },
  { value: 'ACUMULADO_GRUPO', text: 'Acumulado por Grupo de Produto', familia: 'ACUMULADO', agrupamentoPrimario: 'GRUPO' },
  { value: 'ACUMULADO_CFOP', text: 'Acumulado por CFOP', familia: 'ACUMULADO', agrupamentoPrimario: 'CFOP' },
  { value: 'ACUMULADO_PRODUTO', text: 'Acumulado por Produto', familia: 'ACUMULADO', agrupamentoPrimario: 'PRODUTO' },
  { value: 'ACUMULADO_DIA', text: 'Acumulado por Dia', familia: 'ACUMULADO', agrupamentoPrimario: 'DIA' },
  { value: 'ACUMULADO_TIPO', text: 'Acumulado por Tipo', familia: 'ACUMULADO', agrupamentoPrimario: 'TIPO' },
  { value: 'ANALITICO_CLIENTE', text: 'Analitico por Cliente', familia: 'ANALITICO', agrupamentoPrimario: 'CLIENTE' },
  { value: 'ANALITICO_NCM', text: 'Analitico por NCM', familia: 'ANALITICO', agrupamentoPrimario: 'NCM' },
  { value: 'ANALITICO_GRUPO', text: 'Analitico por Grupo de Produto', familia: 'ANALITICO', agrupamentoPrimario: 'GRUPO' },
  { value: 'ANALITICO_CFOP', text: 'Analitico por CFOP', familia: 'ANALITICO', agrupamentoPrimario: 'CFOP' },
  { value: 'ANALITICO_PRODUTO', text: 'Analitico por Produto', familia: 'ANALITICO', agrupamentoPrimario: 'PRODUTO' },
  { value: 'ANALITICO_DIA', text: 'Analitico por Dia', familia: 'ANALITICO', agrupamentoPrimario: 'DIA' },
  { value: 'ANALITICO_TIPO', text: 'Analitico por Tipo', familia: 'ANALITICO', agrupamentoPrimario: 'TIPO' }
]

export default {
  components: {
    ClientePesquisa,
    ProdutoPesquisa,
    EmpresaDropDown,
    GrupoProdutoDropDown,
    CFOPDropDown,
    CecInputData
  },
  data () {
    return {
      tipoRelatorio: 'ANALITICO_DIA',
      filtros: {
        remetenteDestinatarioId: null,
        remetenteId: null,
        cfopId: null,
        produtoId: null,
        grupoProdutoId: null,
        dt1: moment().format('YYYY-MM-DD'),
        dt2: moment().format('YYYY-MM-DD')
      },
      situacao: {
        valor: '',
        opcoes: [
          { value: '', text: 'Todas' },
          { value: '2', text: 'Finalizada' },
          { value: '3', text: 'Cancelada' },
          { value: '7', text: 'Rejeitada' }
        ]
      }
    }
  },
  computed: {
    isDark () {
      return this.$store.getters['tema/IS_DARK']
    },
    isValid () {
      return !!this.filtros.dt1 && !!this.filtros.dt2
    },
    opcoesRelatorio () {
      return TIPOS_RELATORIO
    },
    tipoSelecionado () {
      return TIPOS_RELATORIO.find(item => item.value === this.tipoRelatorio) || TIPOS_RELATORIO[0]
    }
  },
  methods: {
    getLabelFromDropDown (refName, value) {
      if (!value) return ''
      const component = this.$refs[refName]
      if (component && component.options) {
        const option = component.options.find(item => String(item.value) === String(value))
        return option ? option.text : ''
      }
      return ''
    },
    getLabelFromOptions (options, value) {
      const option = options.find(item => String(item.value) === String(value))
      return option ? option.text : ''
    },
    fmtDate (value) {
      return value ? moment(value).format('DD/MM/YYYY') : ''
    },
    fmtNumber (value, digits = 2) {
      return Number(value || 0).toLocaleString('pt-BR', { minimumFractionDigits: digits, maximumFractionDigits: digits })
    },
    getParams () {
      return {
        tipoRelatorio: this.tipoRelatorio,
        dt1: this.filtros.dt1,
        dt2: this.filtros.dt2,
        remetenteDestinatarioId: this.filtros.remetenteDestinatarioId || '',
        remetenteId: this.filtros.remetenteId || '',
        cfopId: this.filtros.cfopId || '',
        produtoId: this.filtros.produtoId || '',
        grupoProdutoId: this.filtros.grupoProdutoId || '',
        situacao: this.situacao.valor || '',
        lbRemetenteDestinatario: this.$refs.remetenteDestinatarioPesquisa?.$refs?.auto?.display || '',
        lbRemetente: this.getLabelFromDropDown('remetentePesquisa', this.filtros.remetenteId),
        lbCfop: this.getLabelFromDropDown('cfopPesquisa', this.filtros.cfopId),
        lbProduto: this.$refs.produtoPesquisa?.$refs?.auto?.display || '',
        lbGrupoProduto: this.getLabelFromDropDown('grupoProdutoPesquisa', this.filtros.grupoProdutoId),
        lbSituacao: this.getLabelFromOptions(this.situacao.opcoes, this.situacao.valor),
        lbUsuario: window.localStorage.getItem('nomeusuario') || ''
      }
    },
    getObservacoes (dados) {
      const filtros = dados.filtros || {}
      return [
        `Periodo de Emissao: ${this.fmtDate(filtros.dt1)} a ${this.fmtDate(filtros.dt2)}`,
        filtros.remetenteDestinatario ? `Remetente/Destinatario: ${filtros.remetenteDestinatario}` : '',
        filtros.remetente ? `Remetente: ${filtros.remetente}` : '',
        filtros.cfop ? `CFOP: ${filtros.cfop}` : '',
        filtros.produto ? `Produto: ${filtros.produto}` : '',
        filtros.grupoProduto ? `Grupo de Produto: ${filtros.grupoProduto}` : '',
        filtros.situacao ? `Situacao: ${filtros.situacao}` : '',
        'Resumo final adicional por CFOP.'
      ].filter(Boolean).join('\n')
    },
    buildPrimaryGroupConfig () {
      const tipo = this.tipoSelecionado.agrupamentoPrimario
      const map = {
        DIA: {
          key: 'GRUPO_PRIMARIO_ID',
          getLabel: row => `Dia: ${this.fmtDate(row.GRUPO_PRIMARIO_ID)}`
        },
        CFOP: {
          key: 'CFOP_ID',
          getLabel: row => `CFOP: ${row.CFOP_ID || ''} - ${row.CFOP_NOME || ''}`
        },
        PRODUTO: {
          key: 'GRUPO_PRIMARIO_ID',
          getLabel: row => `Produto: ${row.GRUPO_PRIMARIO_NOME || ''}`
        },
        PESSOA: {
          key: 'GRUPO_PRIMARIO_ID',
          getLabel: row => `Remetente/Destinatario: ${row.GRUPO_PRIMARIO_NOME || ''}`
        },
        CLIENTE: {
          key: 'GRUPO_PRIMARIO_ID',
          getLabel: row => `Cliente: ${row.GRUPO_PRIMARIO_NOME || ''}`
        },
        NCM: {
          key: 'GRUPO_PRIMARIO_ID',
          getLabel: row => `NCM: ${row.GRUPO_PRIMARIO_NOME || ''}`
        },
        GRUPO: {
          key: 'GRUPO_PRIMARIO_ID',
          getLabel: row => `Grupo: ${row.GRUPO_PRIMARIO_NOME || ''}`
        },
        TIPO: {
          key: 'GRUPO_PRIMARIO_ID',
          getLabel: row => `Tipo: ${row.GRUPO_PRIMARIO_NOME || ''}`
        }
      }
      return map[tipo] || map.DIA
    },
    getGroupBy () {
      if (this.tipoSelecionado.agrupamentoPrimario === 'CFOP') {
        return [{
          key: 'CFOP_ID',
          getLabel: row => `CFOP: ${row.CFOP_ID || ''} - ${row.CFOP_NOME || ''}`
        }]
      }
      return [this.buildPrimaryGroupConfig()]
    },
    getColumns () {
      const number = (digits = 2) => (value) => this.fmtNumber(value, digits)
      const date = (value) => this.fmtDate(value)
      const moeda = (value) => this.fmtNumber(value, 2)

      if (this.tipoSelecionado.familia === 'ANALITICO') {
        return [
          { key: 'NFE_ID', label: 'ID', type: 'number', formatter: number(0), width: '4%' },
          { key: 'NUMERO_NFE', label: 'NF-e', width: '5%' },
          { key: 'DATA_EMISSAO', label: 'Emissao', type: 'date', formatter: date, width: '6%' },
          { key: 'TIPO_EMISSAO', label: 'Tipo', width: '5%' },
          { key: 'SITUACAO', label: 'Situacao', width: '7%' },
          { key: 'EMITENTE_NOME', label: 'Remetente', width: '12%' },
          { key: 'PESSOA_NOME', label: 'Dest./Rem.', width: '13%' },
          { key: 'PRODUTO_NOME', label: 'Produto', width: '12%' },
          { key: 'NCM', label: 'NCM', width: '5%' },
          { key: 'QUANTIDADE', label: 'Qtd.', type: 'number', formatter: number(2), width: '6%' },
          { key: 'CST_ICMS', label: 'CST ICMS', width: '5%' },
          { key: 'CST_PIS', label: 'CST PIS', width: '5%' },
          { key: 'CST_COFINS', label: 'CST COF.', width: '5%' },
          { key: 'VL_TOTAL_LIQUIDO', label: 'Liquido (R$)', type: 'number', formatter: moeda, width: '7%' },
          { key: 'VL_ICMS', label: 'ICMS (R$)', type: 'number', formatter: moeda, width: '6%' },
          { key: 'VL_PIS', label: 'PIS (R$)', type: 'number', formatter: moeda, width: '6%' },
          { key: 'VL_COFINS', label: 'COFINS (R$)', type: 'number', formatter: moeda, width: '6%' },
          { key: 'VL_IPI', label: 'IPI (R$)', type: 'number', formatter: moeda, width: '6%' },
          { key: 'VL_IBS', label: 'IBS (R$)', type: 'number', formatter: moeda, width: '6%' },
          { key: 'VL_CBS', label: 'CBS (R$)', type: 'number', formatter: moeda, width: '6%' },
          { key: 'VL_ISS', label: 'ISS (R$)', type: 'number', formatter: moeda, width: '6%' }
        ]
      }

      return [
        { key: 'QT_NOTAS', label: 'Notas', type: 'number', formatter: number(0), width: '7%' },
        { key: 'QT_ITENS', label: 'Itens', type: 'number', formatter: number(0), width: '7%' },
        { key: 'QUANTIDADE', label: 'Quantidade', type: 'number', formatter: number(2), width: '8%' },
        { key: 'VL_TOTAL_BRUTO', label: 'Bruto (R$)', type: 'number', formatter: moeda, width: '8%' },
        { key: 'VL_TOTAL_DESCONTO', label: 'Desc. (R$)', type: 'number', formatter: moeda, width: '8%' },
        { key: 'VL_TOTAL_LIQUIDO', label: 'Liquido (R$)', type: 'number', formatter: moeda, width: '8%' },
        { key: 'VL_ICMS', label: 'ICMS (R$)', type: 'number', formatter: moeda, width: '7%' },
        { key: 'VL_PIS', label: 'PIS (R$)', type: 'number', formatter: moeda, width: '7%' },
        { key: 'VL_COFINS', label: 'COFINS (R$)', type: 'number', formatter: moeda, width: '8%' },
        { key: 'VL_IPI', label: 'IPI (R$)', type: 'number', formatter: moeda, width: '7%' },
        { key: 'VL_IBS', label: 'IBS (R$)', type: 'number', formatter: moeda, width: '7%' },
        { key: 'VL_CBS', label: 'CBS (R$)', type: 'number', formatter: moeda, width: '7%' },
        { key: 'VL_ISS', label: 'ISS (R$)', type: 'number', formatter: moeda, width: '7%' }
      ]
    },
    getSumKeys () {
      if (this.tipoSelecionado.familia === 'ANALITICO') {
        return ['QUANTIDADE', 'VL_TOTAL_LIQUIDO', 'VL_ICMS', 'VL_PIS', 'VL_COFINS', 'VL_IPI', 'VL_IBS', 'VL_CBS', 'VL_ISS']
      }
      return ['QT_NOTAS', 'QT_ITENS', 'QUANTIDADE', 'VL_TOTAL_BRUTO', 'VL_TOTAL_DESCONTO', 'VL_TOTAL_LIQUIDO', 'VL_ICMS', 'VL_PIS', 'VL_COFINS', 'VL_IPI', 'VL_IBS', 'VL_CBS', 'VL_ISS']
    },
    getResumoCfopColumns () {
      const number = (digits = 2) => (value) => this.fmtNumber(value, digits)
      const moeda = (value) => this.fmtNumber(value, 2)

      return [
        { key: 'CFOP_ID', label: 'CFOP', width: '8%' },
        { key: 'CFOP_NOME', label: 'Descricao CFOP', width: '24%' },
        { key: 'QT_NOTAS', label: 'Notas', type: 'number', formatter: number(0), width: '6%' },
        { key: 'QT_ITENS', label: 'Itens', type: 'number', formatter: number(0), width: '6%' },
        { key: 'QUANTIDADE', label: 'Quantidade', type: 'number', formatter: number(2), width: '8%' },
        { key: 'VL_TOTAL_BRUTO', label: 'Bruto (R$)', type: 'number', formatter: moeda, width: '8%' },
        { key: 'VL_TOTAL_DESCONTO', label: 'Desc. (R$)', type: 'number', formatter: moeda, width: '8%' },
        { key: 'VL_TOTAL_LIQUIDO', label: 'Liquido (R$)', type: 'number', formatter: moeda, width: '8%' },
        { key: 'VL_ICMS', label: 'ICMS (R$)', type: 'number', formatter: moeda, width: '7%' },
        { key: 'VL_PIS', label: 'PIS (R$)', type: 'number', formatter: moeda, width: '7%' },
        { key: 'VL_COFINS', label: 'COFINS (R$)', type: 'number', formatter: moeda, width: '8%' },
        { key: 'VL_IPI', label: 'IPI (R$)', type: 'number', formatter: moeda, width: '7%' },
        { key: 'VL_IBS', label: 'IBS (R$)', type: 'number', formatter: moeda, width: '7%' },
        { key: 'VL_CBS', label: 'CBS (R$)', type: 'number', formatter: moeda, width: '7%' },
        { key: 'VL_ISS', label: 'ISS (R$)', type: 'number', formatter: moeda, width: '7%' }
      ]
    },
    gerarHtml (dados) {
      printGroupedHtmlReport({
        rows: dados.linhas || [],
        columns: this.getColumns(),
        groupBy: this.getGroupBy(),
        sumKeys: this.getSumKeys(),
        systemName: dados.empresa?.FANTASIA || window.localStorage.getItem('nomeempresa') || '',
        reportTitle: `Relatorio de NF-e - ${this.tipoSelecionado.text}`,
        printedBy: window.localStorage.getItem('nomeusuario') || '',
        observations: this.getObservacoes(dados),
        landscape: true,
        autoPrint: false,
        extraSections: this.tipoSelecionado.agrupamentoPrimario === 'CFOP'
          ? []
          : [{
              title: 'Resumo Final por CFOP',
              rows: dados.resumoCfop || [],
              columns: this.getResumoCfopColumns()
            }]
      })
    },
    gerarRelatorio () {
      if (!this.isValid) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o periodo de emissao do relatorio')
        return
      }

      this.$store.commit('controle/setAguardando', true)
      const uri = '/api/protected/relatorios/nfe?' + new URLSearchParams(this.getParams()).toString()
      this.$http.get(uri)
        .then(response => {
          const dados = response.data || {}
          if (!dados.linhas || dados.linhas.length === 0) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'info', 'Nenhuma informacao para o filtro selecionado')
            return
          }
          this.gerarHtml(dados)
        })
        .catch((err) => {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', err || 'Ocorreram erros ao gerar o relatorio')
        })
        .finally(() => {
          this.$store.commit('controle/setAguardando', false)
        })
    }
  }
}
</script>

<style scoped>
.bg-primary-soft { background-color: rgba(32, 168, 216, 0.1); }
.bg-secondary-soft { background-color: rgba(108, 117, 125, 0.1); }
.bg-dark-darker { background-color: #1e2225; }

.section-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e4e7ea;
  transition: all 0.3s ease;
}

.section-container:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.section-container.dark-mode {
  background: #2f353a;
  border-color: #434a50;
}

.section-title {
  color: #20a8d8;
  border-bottom: 1px solid #c2cfd6;
  padding-bottom: 8px;
  margin-bottom: 20px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 1px;
}

.section-title.dark-mode {
  color: #63c2de;
  border-color: #434a50;
}

.btn-generate {
  font-weight: 700;
  letter-spacing: 1px;
  padding: 12px;
  transition: all 0.3s;
}

.btn-generate:hover {
  transform: translateY(-1px);
}
</style>



// WEBPACK FOOTER //
// src/views/relatorios/RelNotaFiscal.vue